<template>
  <div class="big-map-box">
    <div class="map-content" id="scatterMap"></div>
    <div class="map-darkcorner"></div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'AmapScatter',
  props: {
    title: {
      type: String,
      default: ''
    },
    legendColor: {
      type: Array
    },
    chartData: {
      type: Object,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      chart: null,
      map: null,
    }
  },
  mounted() {
    this.initChart()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      // 先根据value洗颜色和symbol大小
      for (let i = 0; i < this.chartData.sourceArea.length; i++) {
        if(!this.chartData.sourceArea[i].hasOwnProperty('coordinate')) {
          continue
        }
        if (this.chartData.sourceArea[i].num >= this.chartData.legendConf[0].min) {
          this.chartData.sourceArea[i].symbolSize = 14
          this.chartData.sourceArea[i].color = this.legendColor[0]
        } else if (
          this.chartData.sourceArea[i].num >= this.chartData.legendConf[1].min
        ) {
          this.chartData.sourceArea[i].symbolSize = 12
          this.chartData.sourceArea[i].color = this.legendColor[1]
        } else if (
          this.chartData.sourceArea[i].num >= this.chartData.legendConf[2].min
        ) {
          this.chartData.sourceArea[i].symbolSize = 10
          this.chartData.sourceArea[i].color = this.legendColor[2]
        } else if (
          this.chartData.sourceArea[i].num >= this.chartData.legendConf[3].min
        ) {
          this.chartData.sourceArea[i].symbolSize = 8
          this.chartData.sourceArea[i].color = this.legendColor[3]
        } else if (
          this.chartData.sourceArea[i].num >= this.chartData.legendConf[4].min
        ) {
          this.chartData.sourceArea[i].symbolSize = 6
          this.chartData.sourceArea[i].color = this.legendColor[4]
        }
      }

      // 洗series
      var series = []
      for (let i = 0; i < this.chartData.sourceArea.length; i++) {
        if(!this.chartData.sourceArea[i].hasOwnProperty('coordinate')) {
          continue
        }
        series.push({
          name: this.chartData.sourceArea[i].name,
          type: 'effectScatter',
          coordinateSystem: 'amap',
          zlevel: 4,
          symbol: 'rect',
          symbolSize: this.chartData.sourceArea[i].symbolSize,
          rippleEffect: {
            scale: 3,
            period: 4,
            brushType: 'stroke'
          },
          label: {
            normal: {
              show: true,
              position: 'bottom',
              formatter: () => {
                return this.chartData.sourceArea[i].name + ' ' + this.chartData.sourceArea[i].num
              },
              color: '#cbeeff',
              fontSize: 8
            }
          },
          itemStyle: {
            normal: {
              color: this.chartData.sourceArea[i].color
            }
          },
          data: [
            {
              name: this.chartData.sourceArea[i].name,
              value: this.chartData.sourceArea[i].coordinate
            }
          ]
        })
      }

      this.chart = this.$echarts.init(document.getElementById('scatterMap'))
      this.chart.setOption({
        amap: {
          zoom: 5,
          zooms: [4, 10],
          mapStyle: 'amap://styles/b5500447492ee5d38f79824b6e68aec4',
          center: this.chartData.curCenter, //中心点
          rotation: 0, //顺时针旋转角度
          resizeEnable: true
        },
        animation: false,
        series: []
      })

      this.map = this.chart
        .getModel()
        .getComponent('amap')
        .getAMap()

      this.chart.setOption({
        series: series
      })
    }
  }
}
</script>

<style scoped lang="less"></style>
